import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, X, Send } from "lucide-react";
import { api, visitorId } from "../../lib/api";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [chat, setChat] = useState(null);
  const [text, setText] = useState("");
  const end = useRef(null);
  const vid = visitorId();

  useEffect(() => {
    if (!open) return;
    if (!chat) api.post("/chat/start", { visitor_id: vid }).then((r) => setChat(r.data));
    const t = setInterval(() => chat && api.get(`/chat/${chat.id}`, { params: { visitor_id: vid } }).then((r) => setChat(r.data)).catch(() => {}), 5000);
    return () => clearInterval(t);
  }, [open, chat?.id]); // eslint-disable-line

  useEffect(() => end.current?.scrollIntoView({ behavior: "smooth" }), [chat?.messages?.length]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim() || !chat) return;
    const { data } = await api.post(`/chat/${chat.id}/messages`, { text, visitor_id: vid });
    setChat(data); setText("");
  };

  return (
    <div className="fixed bottom-20 right-4 z-40 xl:bottom-6 xl:right-6">
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 16, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 16 }}
            className="mb-4 flex h-[460px] w-[calc(100vw-2rem)] max-w-sm flex-col overflow-hidden rounded-lg border border-beige bg-ivoire shadow-[0_30px_60px_rgba(42,24,16,0.2)]" data-testid="chat-panel">
            <div className="flex items-center justify-between bg-brun px-5 py-4 text-ivoire">
              <div><p className="font-serif text-xl !text-ivoire">Un conseiller</p><p className="text-[11px] text-ivoire/60">Réponse humaine, du lundi au samedi</p></div>
              <button onClick={() => setOpen(false)} data-testid="chat-close-btn" aria-label="Fermer"><X size={18} /></button>
            </div>
            <div className="flex-1 space-y-3 overflow-y-auto p-4">
              {chat?.messages?.map((m, i) => (
                <div key={i} className={`max-w-[85%] rounded-lg px-4 py-2.5 text-sm ${m.from === "client" ? "ml-auto bg-bois text-white" : "bg-creme text-encre"}`}>{m.text}</div>
              ))}
              <div ref={end} />
            </div>
            <form onSubmit={send} className="flex gap-2 border-t border-beige p-3">
              <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Votre message…" className="field !py-2.5" data-testid="chat-input" />
              <button className="btn-primary !px-4 !py-2.5" data-testid="chat-send-btn" aria-label="Envoyer"><Send size={15} /></button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>
      <button onClick={() => setOpen((o) => !o)} className="ml-auto flex items-center gap-2 rounded-full bg-brun px-5 py-3.5 text-sm font-medium text-ivoire shadow-[0_12px_30px_rgba(42,24,16,0.3)] transition-transform hover:-translate-y-0.5" data-testid="chat-toggle-btn">
        <MessageCircle size={18} className="text-laiton" /><span className="hidden sm:inline">Un conseiller</span>
      </button>
    </div>
  );
}
